import Phaser from 'phaser';

export class BubbleSystem {
    private scene: Phaser.Scene;
    private bubbles: Phaser.GameObjects.Ellipse[] = [];
    private maxBubbles: number = 20;
    private isActive: boolean = true;
    
    constructor(scene: Phaser.Scene, maxBubbles: number = 20) {
        this.scene = scene;
        this.maxBubbles = maxBubbles;
    }
    
    public start(): void {
        this.isActive = true;
        
        // Create initial bubbles
        for (let i = 0; i < this.maxBubbles; i++) {
            setTimeout(() => {
                if (this.isActive) {
                    this.createBubble();
                }
            }, i * 300);
        }
    }
    
    public stop(): void {
        this.isActive = false;
        
        // Clear all bubbles
        this.bubbles.forEach(bubble => {
            if (bubble && bubble.active) {
                bubble.destroy();
            }
        });
        
        this.bubbles = [];
    }
    
    private createBubble(): void {
        if (!this.isActive || this.bubbles.length >= this.maxBubbles) return;
        
        // Create bubble with random size
        const size = Phaser.Math.Between(5, 15);
        const x = Phaser.Math.Between(0, this.scene.scale.width);
        const bubble = this.scene.add.ellipse(x, this.scene.scale.height + 20, size, size, 0xffffff, 0.2);
        
        this.bubbles.push(bubble);
        
        // Randomize bubble animation parameters
        const duration = Phaser.Math.Between(5000, 15000);
        const horizontalMovement = Phaser.Math.Between(-100, 100);
        
        // Animate bubble rising
        this.scene.tweens.add({
            targets: bubble,
            y: -50,
            x: `+=${horizontalMovement}`,
            duration: duration,
            ease: 'Sine.easeInOut',
            onComplete: () => {
                // Remove from array and destroy
                const index = this.bubbles.indexOf(bubble);
                if (index >= 0) {
                    this.bubbles.splice(index, 1);
                }
                
                if (bubble && bubble.active) {
                    bubble.destroy();
                }
                
                // Create a new bubble if still active
                if (this.isActive) {
                    setTimeout(this.createBubble.bind(this), Phaser.Math.Between(0, 2000));
                }
            }
        });
    }
    
    public update(): void {
        // This can be used for any frame-by-frame updates needed
        // Currently the bubbles are animated with tweens, so no update logic is needed
    }
} 